import styled, {css} from 'styled-components'
import {maxWidth} from 'core/theme'

export const Wrapper = styled.div`
  ${props => props.type === 'info' && css`
    background-color: #449bf7;
  `}
  ${props => props.type === 'success' && css`
    background-color: #4cbf65;
  `}
  ${props => props.type === 'error' && css`
    background-color: #da5a5a;
  `}
  position: relative;
  padding: 20px;
  border-radius: 4px;
  display: block;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.03);
  width: 540px;
  box-sizing: border-box;
  margin: 30px;
  ${maxWidth.small`
    width: calc(100vw - 20px);
    margin: 10px;
  `}
  p {
    color: #f2f2f2;
    font-weight: 500;
    margin: 0 10px 0 0;
    font-size: 17px;
    a {
      font-size: 1em;
      color: #f2f2f2;
      text-decoration: underline;
      font-weight: bold;
    }
    ${maxWidth.small`
      font-size: 16px;
    `}
  }
  button {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    right: 10px;
    color: #f2f2f2;
    text-decoration: none;
    font-size: 40px;
    font-family: Lato, Arial, sans-serif;
    background: none;
    border: none;
    outline: none;
    ${maxWidth.small`
      right: 5px;
    `}
  }  
`
